/* eslint-disable no-undef */
import { LogLevel } from '@azure/msal-browser';

const {
  REACT_APP_SSO_CLIENT_ID,
  REACT_APP_SSO_AUTHORITY,
  REACT_APP_SSO_REDIRECT_URI,
  REACT_APP_SSO_POST_LOGOUT_REDIRECT_URI,
} = process?.env || {};

export const msalConfig = {
  auth: {
    clientId: REACT_APP_SSO_CLIENT_ID,
    authority: REACT_APP_SSO_AUTHORITY,
    redirectUri: REACT_APP_SSO_REDIRECT_URI,
    postLogoutRedirectUri: REACT_APP_SSO_POST_LOGOUT_REDIRECT_URI,
    navigateToLoginRequestUrl: false,
  },
  cache: {
    cacheLocation: 'sessionStorage',
    storeAuthStateInCookie: false,
  },
  system: {
    loggerOptions: {
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) {
          return;
        }
        switch (level) {
          case LogLevel.Error:
            // console.error(message);
            return;
          case LogLevel.Info:
            // console.info(message);
            return;
          case LogLevel.Verbose:
            // console.debug(message);
            return;
          case LogLevel.Warning:
            // console.warn(message);
            return;
          default:
            return;
        }
      },
    },
  },
};

export const loginRequest = {
  scopes: ['profile', 'email'],
};
